import React from "react";
import { Link } from "react-router-dom";

// WorkOnIT wordmark: "Work" in blue, "OnIT" in teal with a connecting-node arc over the O.
export function LogoMark({ size = "text-2xl", asLink = true, className = "" }) {
  const content = (
    <span dir="ltr" translate="no" style={{ unicodeBidi: "isolate" }} className={`notranslate font-display font-extrabold ${size} inline-flex items-center tracking-tight leading-none ${className}`}>
      <span className="text-blue-400">Work</span>
      <span className="relative inline-block text-teal-300 px-[0.02em]">
        <span className="relative">O</span>
        <svg viewBox="0 0 44 22" className="absolute left-1/2 -translate-x-1/2 -top-[0.38em] w-[1.55em] h-[0.78em] overflow-visible" aria-hidden="true">
          <path d="M5 18 C 12 3, 32 3, 39 13" stroke="#2DD4BF" strokeWidth="2.6" fill="none" strokeLinecap="round" />
          <circle cx="39" cy="13" r="3.2" fill="#2DD4BF" className="blip" />
          <circle cx="5" cy="18" r="2.2" fill="#5EEAD4" />
        </svg>
      </span>
      <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-300 to-cyan-400">niT</span>
    </span>
  );
  if (!asLink) return content;
  return <Link to="/" data-testid="navbar-brand-logo" className="inline-flex">{content}</Link>;
}

export default function Logo({ className = "", size = "text-2xl" }) {
  return <LogoMark size={size} className={className} asLink />;
}
